import React from 'react';
import '../assets/styles/PasoAPaso.scss';

const PasoAPasoContainer = () => (

  <div className='pasoAPasoContainer'>
    <h1 className='mainTitleCovid'>Que significa el Paso 3 En Preparación?</h1>
    <h2 className='mainTitleCovid'>¿Qué puedo hacer?</h2>
    <p>
      Puedes salir todos los días de la semana, pero no puedes ir a un lugar en cuarentena.
      <br />
      Debes respetar el toque de queda, que implica que no puedes salir entre las 22:00 y la 05:00 horas salvo que tengas un salvoconducto por emergencia médica o el fallecimiento de un familiar directo.
      <br />
      Puedes ir a trabajar si es que trabajas en un lugar que no esté en cuarentena, a no ser que sea servicio esencial, y tengas un permiso de desplazamiento colectivo o un permiso único colectivo.
      <br />
      Participar en eventos, reuniones sociales y recreativas de máximo 50 personas.
      <br />
      Realizar actividad deportiva y participar en deportes colectivos con máximo 5 personas en lugares cerrados (excepto gimnasios de acceso público) y 25 en lugares abiertos. Sin
      público.
      <br />
      Si eres mayor de 75 años, podrás salir a pasear una vez al día, todos los días, por 60 minutos, entre las 10:00 y las 12:00 horas o entre las 15:00 y las 17:00 horas.
      <br />
      Cada vez que salgas, debes usar mascarilla, mantener la distancia física y recordar medidas como lavado de manos o uso de alcohol gel.
      <br />
    </p>
    <h2 className='mainTitleCovid'>¿Qué puede funcionar en mi comuna?</h2>
    <p>
      Farmacias, supermercados y otros lugares de abastecimiento de alimentos y productos básicos, centros de salud y establecimientos de servicio público.
      <br />
      Comercio y otras actividades no esenciales que puedan funcionar con trabajadores que vivan en una comuna sin cuarentena.
      <br />
      Todo lo que funcione, debe ser siguiendo los protocolos establecidos
      <br />
    </p>

    <h2 className='mainTitleCovid'>¿Qué está prohibido en mi comuna? </h2>
    <p>
      El funcionamiento de Clubes y Centros de día de Adulto Mayores.
      <br />
      El funcionamiento de cines, teatros, pubs, discotecas y lugares análogos.
      <br />
      La atención de público en restaurantes y cafés.
      <br />
      El funcionamiento de gimnasios abiertos al público.
      <br />
      La realización de actividad deportiva con más de 25 personas en lugares abiertos y más de 5 en lugares cerrados.
      <br />
      La realización y participación de eventos y reuniones sociales y recreativas de más de 50
      personas.
      <br />
      La entrada y salida a Centros SENAME y ELEAM.
      <br />
      El traslado a segunda vivienda.
      <br />
      El libre tránsito por fronteras terrestres y áreas, a no ser que la autoridad competente
      indique lo contrario.
      <br />
      La realización de cirugías electivas no críticas, exceptuando cirugía mayor ambulatoria y con hospitalización de máximo una noche, a no ser que la autoridad competente indique lo contrario.
      <br />
      Las clases presenciales de establecimientos educacionales, salvo situaciones excepcionales, previa solicitud del alcalde y cumpliendo las condiciones sanitarias.
    </p>
    <div className='covidContainer'>
      <h2>Modo Covid Estrategia Sanitaria Permanente</h2>
      <h4>
        Aislamiento obligatorio para: casos confirmados, sospechosos y probables.
        <br />
        Cuarentena obligatoria para contactos estrechos de casos confirmados
        Cuarentena obligatoria para quienes ingresan al país.
        <br />
        Uso de mascarilla en lugares cerradosy abiertos urbanos, y transporte público y privado.
        <br />
        Mantener en todo momento un distanciamiento físico mínimo de un metro entre sí, excepción medios de transporte y lugares con aforo regulado específicamente.
        <br />
        Limpieza y desinfección permanente de lugares de atención, espacios de trabajo, herramientas y elementos de trabajo, y lugares de uso común, de acuerdo a protocolo de MINSAL.
        <br />
        Entrega de información sobre aforo máximo, distanciamiento físico y obligaciones y recomendaciones de autocuidado.
      </h4>
    </div>
  </div>
);
export default PasoAPasoContainer;
